import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Input } from 'antd';
import { ChangeCircle } from '@mui/icons-material';

interface Props {
  onSearch?: (value: string) => void;
  onExecute: () => void;
  isActionDisabled: boolean;
  isLoading: boolean;
  actionText: string;
  showSearch?: boolean;
  title?: string;
}

export const ActionBar: React.FC<Props> = ({ onSearch = () => {}, onExecute, isActionDisabled, isLoading, actionText, showSearch = true, title }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, backgroundColor: '#fafafa', borderRadius: 1, border: '1px solid #e0e0e0' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
        {title && <Box sx={{ fontWeight: 600, fontSize: '0.9rem', color: '#1e3a5f' }}>{title}</Box>}
        {showSearch && (
          <Input.Search size="middle" placeholder="Rechercher..." allowClear onChange={(e) => onSearch(e.target.value.trim())} style={{ maxWidth: 250 }} />
        )}
      </Box>
      <Button
        variant="contained"
        disabled={isActionDisabled || isLoading}
        onClick={onExecute}
        startIcon={<ChangeCircle />}
        endIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
        sx={{ backgroundColor: 'var(--primaryColor, #116599)', '&:hover': { backgroundColor: 'var(--darkColor, rgb(13, 74, 112))' }, px: 3, py: 0.5 }}
        size="small"
      >
        {actionText}
      </Button>
    </Box>
  );
};